// Smartsetup Application Configuration
//======================================================================================//
// Application Basic Info
export const appName = "Project setup";

// Turn this flag on for tpttest , enables multi program publish flow
export const multiProgramFlag = false;
//======================================================================================//
// Application API URLs UAT
export const appBaseUrl = "https://uatltbi.duredemos.com/";
export const appApiUrl = "https://uatltbi.duredemos.com/service/api/";

// Application API URLs LIVE
// export const appBaseUrl = "https://tptdemo.imonitorplus.com/";
// export const appApiUrl = "https://tptdemo.imonitorplus.com/service/api/";

// Application API URLs Dev
// export const appBaseUrl = "https://tpttest.imonitorplus.com/";
// export const appApiUrl = "https://tpttest.imonitorplus.com/service/api/";

// Application API URLs Local
// export const appBaseUrl = "http://localhost:8080/";
// export const appApiUrl = "http://localhost:8080/dhis/api/";
//======================================================================================//

